<template>
  <div class="loginbg">
    <div class="contentfrom">
      <img :src="headLogo" width="130"/>
      <H1 class="loginTitle">{{ assessName}}</H1>
      <el-card class="box-card">
        <el-form ref="login" :model="form" label-width="0" :rules="ruleLogin">
          <el-form-item style="margin-top:40px;" prop="studentId">
            <el-input placeholder="请输入学号" v-model.trim="form.studentId">
              <img src="../images/account.png" slot="prepend" width="20"/>
            </el-input>
          </el-form-item>
          <el-form-item style="margin-top:40px;" prop="password">
            <el-input placeholder="请输入密码" v-model.trim="form.password" type="password">
              <img src="../images/password.png" slot="prepend" width="20"/>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button @click="login" type="primary" style="width: 100%; margin: 20px 0" round class="mt20">登录</el-button>
        <p>注：请输入学号和密码登录，未注册用户请点击下方客服按钮。</p>
        <p style="text-align: right; font-size: 10px; color: #409EFF" id="yingyuchat" @click="contactCustomerService">联系客服</p>
      </el-card>
    </div>
    
    <div class="foot">
      <p>Copyright © www.rennengda.com All Rights Reserved.</p>
    </div>
  </div>
</template>
<script>
import HttpRequest from "@/utils/request";
import {setSessionData} from "../utils/cache";
import md5 from 'js-md5'
import {parseQuestNameByCode} from "@/assets/js/questIntro";

export default {
  name: "leftMenu",
  data() {
    return {
      ruleLogin: {
        studentId: [
          {required: true, message: '请输入学号', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, message: '密码长度至少6位', trigger: 'blur'}
        ],
      },
      form: {
        partner: null,
        studentId: "",
        password: "",
      },
      headLogo: '',
      assessName: '',
      openOtherHomepage: '0',
      urlObj: '',
      //定义加密是否一致
      flag: false,
      encryptedQuestCode: '',
      urlParams: '',
    };
  },
  created() {
    let partner = this.$route.query.partner
    let command = this.$route.query.command
    if (!partner || partner === 'undefined') {
      this.$alert('登录网址不对');
    } else {
      this.form.partner = partner
      this.headLogo = 'https://sys.rennengda.com/consult/logos/head-' + partner + '.png';
      this.openOtherHomepage = this.$route.query.openOtherHomepage
      this.assessName = parseQuestNameByCode(command)
    }
    //加密
    let urlObjArr = window.location.search.split('?')
    const urlObj = urlObjArr[1];
    console.log(urlObj);
    let urlObjMap = Object.fromEntries(new URLSearchParams(urlObj));
    this.urlObj = urlObjMap
    //进行排序
    const keySort = Array.from(Object.keys(urlObjMap)).sort();
    // 生成排序后的参数字符串
    keySort.forEach((key) => {
      if (key !== 'sign') { //排除sign参数
        const value = urlObjMap[key];
        this.urlParams += `${key}=${value}&`;
      }
    })
    const secreKey = 'shengya100';
    let sign = md5(this.urlParams + secreKey)
    sign = sign.substring(sign.length - 16);
    console.log(sign)
    //判断加密是否一致
    this.flag = sign === this.urlObj.sign
    if (!this.flag || !(urlObj.includes("partner") && urlObj.includes("command") && urlObj.includes("sign"))) {
      // 跳转 非法参数
      this.$router.push('/error')
    }
    this.form.partner = urlObjMap['partner']
    if (!this.form.partner || this.form.partner == "undefined") {
      this.$alert("登录网址不对");
    }
  },
  mounted() {
  },
  methods: {
    contactCustomerService() {
      let partner = this.$route.query.partner
      this.$router.push("/customerService" + '?partner=' + partner)
    },
    getAdmin(partner, token, name) {
      let url = "/constub/gainAdminMenu";
      HttpRequest.requestFormPost(url, {partner: partner, token: token}).then((res) => {
        let admin = res.data
        store.dispatch('setAdmin', admin)
        if (name){
          this.$router.push({
            name: 'simpleQuestIntro',
            params: {'questCode': this.urlObj.command}
          })
        } else {
          this.$alert('首次登录，请先填写个人资料', {
            showClose: false,
            confirmButtonText: '继续',
            callback: action => {
              this.$router.push('/firstPersonalData?pathfrom=' + this.urlObj.command);
            }
          });
        }
      });
    },
    login() {
      this.$refs["login"].validate((valid) => {
        let partner = this.form.partner
        if (valid) {
          let url = "/constub/loginByStudentId";
          let data = {partner: partner, studentId: this.form.studentId, password: this.form.password};
          HttpRequest.requestFormPost(url, data).then((res) => {
            if (res && res.result.success) {
              setSessionData("partner", partner)
              setSessionData("logoutUrl", null);
              setSessionData("loginPage", "loginByStudentId");
              store.dispatch('setStudent', res.data)
              store.dispatch('setLoginStatus', 1)
              this.getAdmin(partner, res.data.token, res.data.studentName)
            } else {
              this.$alert(res.result.message, {
                confirmButtonText: '确定',
                showClose: false,
              });
            }
          });
        }
      })
    },
  },
};
</script>

<style scoped>
.loginbg {
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: url('../images/bg.png');
  background-size: cover
}

.contentfrom {
  position: absolute;
  width: 80%;
  left: 50%;
  top: 5px;
  transform: translateX(-50%);
  text-align: center;
}

.contentfrom input {
  border: 0;
}

>>> .el-input-group__append,
>>> .el-input-group__prepend {
  border: 0;
  border-radius: 0;
  background: none;
  border-bottom: 1px solid #8d93b9;
}

>>> .el-input__inner {
  color: #8d93b9;
  background: none;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #8d93b9;
}

.loginTitle {
  margin: 20px 0 40px;
  color: #fff;
}

.foot {
  position: absolute;
  width: 80%;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  text-align: center;
  color: #fff;
}
</style>
